import { useCallback } from 'react';
import { useSelector } from 'react-redux';

const useAuth = () => {
  const { isAuthenticated, isValidatingToken, loginUser, impersonatedUser } = useSelector((state) => state.auth);
  let {
    assignedDivisions,
    assignedClients,
    assignedLocations,
    assignedSourceSystems,
    assignedProjects,
    assignedSuppliers,
    assignedContracts,
    assignedFleets,
    dateFormat,
    dateTimeFormat,
    permissionSet,
    // added for petrohub user
    permissions,
    userToRoles,
    userAddressList,
    userContactList,
    // end of petrohub user additions
    username,
    isClientOnHold
  } = loginUser || {};

  const { token } = loginUser || {};
  let { user } = loginUser || {};
  if (impersonatedUser) {
    user = impersonatedUser.user;
  }

  let timezone = user ? user.Timezone : '';

  if (impersonatedUser) {
    assignedDivisions = impersonatedUser.assignedDivisions;
    assignedClients = impersonatedUser.assignedClients;
    assignedLocations = impersonatedUser.assignedLocations;
    assignedSourceSystems = impersonatedUser.assignedSourceSystems;
    assignedProjects = impersonatedUser.assignedProjects;
    assignedSuppliers = impersonatedUser.assignedSuppliers;
    assignedFleets = impersonatedUser.assignedFleets;
    assignedContracts = impersonatedUser.assignedContracts;
    dateFormat = impersonatedUser.dateFormat;
    dateTimeFormat = impersonatedUser.dateTimeFormat;
    permissionSet = impersonatedUser.permissionSet;
    permissions = impersonatedUser.permissions;
    userToRoles = impersonatedUser.userToRoles;
    userAddressList = impersonatedUser.userAddressList;
    userContactList = impersonatedUser.userContactList;
    userToRoles = impersonatedUser.userToRoles;
    username = impersonatedUser.Username;
    isClientOnHold = impersonatedUser.isClientOnHold;

    if (impersonatedUser.user) {
      timezone = impersonatedUser.user.Timezone;
    }

    if (!dateFormat) {
      dateFormat = 'mm-dd-yyyy';
    }
  }

  const changePermissionCodeNameForPetrohub = (code) => {
    // This function is to change permission code name coming from petrohub API to match with permission codes used in ABV, as currently we are using dummy permissions data for petrohub user and the permission codes in that dummy data are different from the ones used in ABV. We can remove this function once we get the actual permissions data from petrohub API with matching permission codes.
    switch (code) {
      case 'client':
        return 'Client';
      case 'cylinder':
        return 'Cylinder';
      case 'order':
        return 'Order';
      case 'Action':
        return 'Action';
      case 'RM':
        return 'Role';
      case 'UM':
        return 'User';
      case 'MyActions':
        return 'MyActions';
      default:
        return code;
    }
  };
  const isAuthorized = useCallback(
    ({ permissionCode }) => {
      if (!permissionSet || !permissionCode || !permissions) {
        return false;
      }
      if (window.location.hostname.toLowerCase().startsWith('localhost') || window.location.hostname.toLowerCase().startsWith('petrohub')) {
        // console.log('Checking authorization for permission code: ', permissions, permissionCode);
        return permissions.some((permission) => permission.Code.toLowerCase() === changePermissionCodeNameForPetrohub(permissionCode).toLowerCase());
      }
      return permissionSet[permissionCode.toLowerCase()];
    },
    [permissionSet, permissions]
  );
  const isAuthorizedPetrohub = useCallback(
    ({ permissionCode }) => {
      if (!permissions || !permissionCode) {
        return false;
      }
      // console.log('Checking authorization for permission code: ', permissions, permissionCode);
      return permissions.some((permission) => permission.Code.toLowerCase() === changePermissionCodeNameForPetrohub(permissionCode).toLowerCase());
    },
    [permissions]
  );
  return {
    isAuthenticated,
    isValidatingToken,
    user,
    token,
    username,
    permissionSet,
    assignedDivisions,
    assignedFleets,
    assignedContracts,
    assignedClients,
    assignedLocations,
    assignedSourceSystems,
    assignedProjects,
    assignedSuppliers,
    dateFormat,
    dateTimeFormat,
    timezone,
    isAuthorized,
    isAuthorizedPetrohub,
    isClientOnHold,
    userAddressList,
    userToRoles,
    userContactList,
  };
};

export default useAuth;
